import React, { useEffect } from 'react';
import { useLayout } from '../../LayoutContext';
import Header from '../../components/header/Header';
import { UrgencyStyle } from './formsStyle';
import cornerRightArrow from '../../components/assets/corner-right-down.svg';
import Logo from '../../components/assets/omint-pride.svg';
import imageSource from '../../components/assets/urgencia.webp';
import { useNavigate } from 'react-router-dom';
import videoSource from '../../components/assets/Video_forms.mp4';
import FooterBack from '../../components/footer/FooterBack';

const FormUrgency = () => {
  const navigate = useNavigate();

  const { setLayoutConfig } = useLayout(); // Usa o hook para acessar a função de configuração

  useEffect(() => {
    // Configura a cor de fundo e o conteúdo do cabeçalho específicos para HomePage
    setLayoutConfig({
      backgroundColor: '#00022D',
      headerContent: {
        // Defina aqui os dados específicos do cabeçalho para a HomePage
      },
    });
  }, [setLayoutConfig]);

  const handleYesterday = () => {
    sessionStorage.setItem('@urgency', JSON.stringify('Quero pra ontem'));

    navigate('/simulacao/8');
  };

  const handleWeek = () => {
    sessionStorage.setItem('@urgency', JSON.stringify('Em até uma semana'));

    navigate('/simulacao/8');
  };

  const handleFortnight = () => {
    sessionStorage.setItem('@urgency', JSON.stringify('Nos próximos 15 dias'));

    navigate('/simulacao/8');
  };

  const handleMonth = () => {
    sessionStorage.setItem('@urgency', JSON.stringify('Em até um mês'));

    navigate('/simulacao/8');
  };

  const handleUndetermined = () => {
    sessionStorage.setItem('@urgency', JSON.stringify('Talvez mais de um mês'));

    navigate('/simulacao/8');
  };

  return (
    <>
      <UrgencyStyle>
        <section className="formUrgency__wrapper col-12">
          <div className="container col-12">
            <div className="logo-form">
              <img className="logo" src={Logo} alt="Logo" height={75} />
            </div>

            <div className="title__wrapper">
              <h1 className="title">
                Em quanto tempo você gostaria de resolver essa questão?
              </h1>
            </div>

            <div className="buttons__wrapper">
              <a className="button_link" onClick={handleYesterday}>
                <p className="button_text">Quero pra ontem</p>
              </a>

              <a className="button_link" onClick={handleWeek}>
                <p className="button_text">Em até uma semana</p>
              </a>

              <a className="button_link" onClick={handleFortnight}>
                <p className="button_text">Nos próximos 15 dias</p>
              </a>

              <a className="button_link" onClick={handleMonth}>
                <p className="button_text">Em até um mês</p>
              </a>

              <a className="button_link" onClick={handleUndetermined}>
                <p className="button_text">Mais de um mês</p>
              </a>
            </div>
          </div>
        </section>
        <FooterBack />
      </UrgencyStyle>
    </>
  );
};

export default FormUrgency;
